import '../vendor/jquery.cookie';
import '../vendor/svgxuse';
import '../vendor/polyfill-array-from';
import '../vendor/polyfill-array-forEach';
import menu from './modules/menu-and-filter-animation';
import sticky from './modules/sticky-filter';
import slider from './modules/slider';
import cards from './modules/cards';
import persons from './modules/persons';
import LazyLoad from "vanilla-lazyload";
import blur from "./modules/blur";
import directors from "./modules/directors";
import directorReadMore from "./modules/director-read-more";
import directorVideos from "./modules/director-videos";

document.addEventListener("DOMContentLoaded", function() {
    blur.init();
    menu.init();
    sticky.init();
    slider.init();
    cards.init();
    persons.init();
    directors.init();
    directorReadMore.init();
    directorVideos.init();

    const lazy = new LazyLoad({
        elements_selector: '.lazy'
    });
});

let requireAll = r => r.keys().forEach(r);

requireAll(require.context('../../icons/', true, /\.svg$/));